<template>
  <header id="header" role="banner" v-if="project">
    <div class="main-nav">
      <slot name="progress"></slot>
      <div class="container">
        <div class="header-top"></div>
          <div class="row">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <router-link
                v-if="project.logo"
                :to="{name: 'home'}"
                v-scroll-to="'body'">
                <a class="navbar-brand" href="/">
                  <img class="img-responsive" :src="project.logo" :alt="project.name">
                </a>
              </router-link>

            </div>
            <div class="collapse navbar-collapse">
              <ul class="nav navbar-nav navbar-right bos-nav">
                <router-link
                  tag="li"
                  :to="{name: 'home'}"
                  v-scroll-to="'#about'">
                  <a>About</a>
                </router-link>

                <li v-if="votingLink">
                  <a :href="project.voting_link" target="_blank">Vote</a>
                </li>

                <router-link
                  tag="li"
                  :to="{name: 'home'}"
                  v-scroll-to="'#gallery'">
                  <a>Explore</a>
                </router-link>

                <router-link
                  tag="li"
                  :to="{name: 'home'}"
                  v-scroll-to="'#contact'">
                  <a>Contact Us</a>
                </router-link>
                <li><a href="https://www.newsreview.com/sacramento/home" target="_blank">SN&amp;R Website</a></li>
              </ul>
            </div>
          </div>
        </div>
    </div>
  </header>
</template>

<script>
import {mapGetters} from 'vuex'
import {menuSetup} from '@/utils/menu'

export default {
  props: {
    project: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'votingLink'
    ])
  },
  mounted () {
    menuSetup()
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  .main-nav {
    a {
      font-family: $default-font-primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue